import { onEvent } from '../util/domutils'; // eslint-disable-line import/named
import initFlyout from '../components/flyoutUnderHeader';
import 'fetch-jsonp-polyfill';

const base = {};

base.initStoresModal = () => {
  const storesContainer = document.querySelector('.appointments__stores__pane');

  initFlyout(storesContainer);
  storesContainer.setAttribute('initialized', 'true');
};

base.devaticsURLs = {
  getStores: `${document.querySelector('.appointments').dataset.getStoresUrl}ps/getallstores`,
};

base.storesByAppointment = [
  {
    id: 1,
    name: 'bridal',
    displayName: 'Bridal',
    storesList: [],
  },
  {
    id: 2,
    name: 'bridesmaid',
    displayName: 'Bridesmaid',
    storesList: [],
  },
  {
    id: 3,
    name: 'special',
    displayName: 'Special Occasion',
    storesList: [],
  },
  {
    id: 4,
    name: 'wardrobe',
    displayName: 'Wardrobe Update',
    storesList: [],
  },
];

const saveStoresByAppointmentToSessionStorage = (storesList) => {
  storesList.forEach((store) => {
    store.appointmentTypes.forEach((storeAppointmentType) => {
      if (base.storesByAppointment.find(appointmentType => appointmentType.id === storeAppointmentType.id)) {
        base.storesByAppointment[storeAppointmentType.id - 1].storesList.push(store);
      }
    });
  });

  // add data to the session storage
  if (!sessionStorage.getItem('storesByAppointment')) {
    sessionStorage.setItem('storesByAppointment', JSON.stringify(base.storesByAppointment));
  }
};

base.getAllStoresAjax = () => {
  $(document).ready(function () { //eslint-disable-line
    fetch(base.devaticsURLs.getStores, {
      method: 'JSONP',
      timeout: 5000,
    })
      .then(res => res.json())
      .then((storesList) => {
        saveStoresByAppointmentToSessionStorage(storesList);
      });
  });
};

const sortStoresByRegion = (storesToBeSorted) => {
  const storesByRegion = {
    scotland: {
      displayName: 'Scotland',
      storesList: [],
    },
    north: {
      displayName: 'North',
      storesList: [],
    },
    midlands: {
      displayName: 'Midlands & East England',
      storesList: [],
    },
    south: {
      displayName: 'South',
      storesList: [],
    },
    london: {
      displayName: 'London & South East',
      storesList: [],
    },
    southWest: {
      displayName: 'South West & Wales',
      storesList: [],
    },
    northernIreland: {
      displayName: 'Northern Ireland',
      storesList: [],
    },
  };

  storesToBeSorted.forEach((store) => {
    switch (store.region.id) { // eslint-disable-line default-case
      case 1: storesByRegion.scotland.storesList.push(store); break;
      case 2: case 3: storesByRegion.north.storesList.push(store); break;
      case 4: case 5: storesByRegion.midlands.storesList.push(store); break;
      case 6: case 9: storesByRegion.south.storesList.push(store); break;
      case 7: case 10: storesByRegion.london.storesList.push(store); break;
      case 8: storesByRegion.southWest.storesList.push(store); break;
      case 11: storesByRegion.northernIreland.storesList.push(store); break;
    }
  });

  return storesByRegion;
};

base.sortStoresByRegionOnClick = () => {
  onEvent(document, 'click', '.available-stores-link', (e) => {
    const clickedItem = e.target;
    // get item property value - so appointment type is picked up
    const appType = clickedItem.dataset.appointmentType;
    // get stores by appType from sessionStorage
    const storesByAppType = JSON.parse(sessionStorage.getItem('storesByAppointment'));
    const storesBySelectedAppType = storesByAppType.find(appointmentList => appointmentList.name === appType);
    // sort by region
    const storesByRegion = sortStoresByRegion(storesBySelectedAppType.storesList);

    // set heading's appointment type
    document.querySelector('span.heading-app-type').innerText = storesBySelectedAppType.displayName;
    // get accordion tag; create and modify its children - accordion-element-s
    const accordionRegions = document.getElementById('accordion-regions');
    const accordionElement = accordionRegions.querySelector('.accordion-element');

    // clear existing accordion elements by replacing accordion current node with an empty node
    const accordionRegionsEmptyNode = accordionRegions.cloneNode(false);
    document.querySelector('.appointments__stores__container')
      .replaceChild(accordionRegionsEmptyNode, accordionRegions);

    Object.keys(storesByRegion).forEach((regionKey) => {
      if (storesByRegion[regionKey].storesList.length) {
        const cloneAccordionElement = accordionElement.cloneNode(true);
        // set accordion element title
        const accordionElementTitle = cloneAccordionElement.querySelector('.accordion-element-title');
        accordionElementTitle.setAttribute('id', regionKey);
        accordionElementTitle.querySelector('a.title-link').setAttribute('href', `#collapse-${regionKey}`);
        accordionElementTitle.querySelector('a.title-link').setAttribute('aria-controls', `#collapse-${regionKey}`);
        accordionElementTitle.querySelector('a.title-link')
          .querySelector('span').innerText = storesByRegion[regionKey].displayName;

        // set accordion element content
        const accordionElementContent = cloneAccordionElement.querySelector('.accordion-element-content');
        accordionElementContent.setAttribute('aria-labelled-by', 'regionKey');
        accordionElementContent.setAttribute('id', `collapse-${regionKey}`);

        storesByRegion[regionKey].storesList.forEach((store) => {
          // remove old list of stores and add new ones
          const storesHtmlList = accordionElementContent.querySelector('ul');
          while (storesHtmlList.hasChildNodes()) {
            storesHtmlList.removeChild(storesHtmlList.lastChild);
          }
          const storeLiNode = document.createElement('li');
          const appointmentLink = document.createElement('a');
          appointmentLink.setAttribute(
            'href',
            `${storesHtmlList.dataset.url}?appType=${storesBySelectedAppType.id}&storeId=${store.id}`,
          );
          appointmentLink.innerText = store.name;
          storeLiNode.appendChild(appointmentLink);
          storesHtmlList.appendChild(storeLiNode);
        });

        accordionRegionsEmptyNode.appendChild(cloneAccordionElement);
      }
    });
  });
};

export default base;
